import { badgeVariants } from "@volca/ui/components/ui/badge";
import { cn } from "@volca/ui/lib/utils";

interface AttentionCountProps {
  count: number;
  label: string;
  isPartial?: boolean;
  className?: string;
}

export const AttentionCount = ({
  count,
  label,
  isPartial = false,
  className,
}: AttentionCountProps) => (
  <span
    className={badgeVariants({
      variant: "secondary",
      color: "warning",
      size: "sm",
      className: cn("tabular-nums", className),
    })}
  >
    <span aria-hidden>
      {count}
      {isPartial ? "+" : ""}
    </span>
    <span className="sr-only">
      {`, ${count}${isPartial ? " or more" : ""} ${label}`}
    </span>
  </span>
);
